import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FileText, Mail } from 'lucide-react';
import { PageWrapper } from '../components/EditorialShared';

export const TerminosPage = () => {
  const heroRef = useRef(null);
  const isHeroInView = useInView(heroRef, { once: true });

  const Section = ({ title, children }) => (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: 0.1 }}
      className="pb-8 border-b border-white/10 last:border-b-0"
    >
      <h2 className="text-white text-xl font-medium mb-4">{title}</h2>
      {children}
    </motion.section>
  );

  return (
    <PageWrapper showLogoFooter={false}>
      <div className="pt-32 pb-20">
        {/* Hero */}
        <section className="max-w-4xl mx-auto px-6 mb-16" ref={heroRef}>
          <motion.div
            className="flex items-center gap-4 mb-8"
            initial={{ opacity: 0, y: 20 }}
            animate={isHeroInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.3 }}
          >
            <div className="w-14 h-14 bg-white/5 rounded-2xl flex items-center justify-center border border-white/10">
              <FileText className="w-7 h-7 text-white/60" />
            </div>
            <div>
              <motion.h1 
                className="text-4xl md:text-5xl font-extralight text-white"
                initial={{ opacity: 0, y: 30 }}
                animate={isHeroInView ? { opacity: 1, y: 0 } : {}}
                transition={{ delay: 0.5 }}
              >
                Términos y Condiciones
              </motion.h1>
              <p className="text-white/40 text-sm mt-1">Última actualización: Febrero 2026</p>
            </div>
          </motion.div>
        </section>

        {/* Content */}
        <main className="max-w-4xl mx-auto px-6">
          <div className="space-y-10">
            <Section title="1. Aceptación de los Términos">
              <p className="text-white/60 leading-relaxed">
                Al acceder y utilizar los servicios de Paliacate Studio, usted acepta estar sujeto a estos Términos y Condiciones.
              </p>
            </Section>

            <Section title="2. Descripción de los Servicios">
              <ul className="space-y-2 text-white/60">
                <li>• Servicios de branding e identidad visual</li>
                <li>• Fotografía gastronómica, de producto y corporativa</li>
                <li>• Gestión y análisis de redes sociales</li>
                <li>• Portal de clientes para gestión de proyectos</li>
              </ul>
            </Section>

            <Section title="3. Pagos y Facturación">
              <ul className="space-y-2 text-white/60">
                <li>• Se requiere un anticipo del 50% para iniciar proyectos</li>
                <li>• El saldo restante se paga al entregar los archivos finales</li>
                <li>• Los pagos recurrentes se facturan mensualmente</li>
              </ul>
            </Section>

            <Section title="4. Contacto">
              <p className="text-white/60 mb-4">
                Si tiene preguntas, puede contactarnos en:
              </p>
              <div className="bg-white/5 rounded-xl p-6 border border-white/10">
                <p className="text-white font-medium mb-2">Paliacate Studio</p>
                <div className="flex items-center gap-2 text-white/60">
                  <Mail className="w-4 h-4" />
                  <a href="mailto:hola@paliacatestudio.com" className="hover:text-white transition-colors">
                    hola@paliacatestudio.com
                  </a>
                </div>
              </div>
            </Section>

            {/* Links */}
            <section className="pt-8 border-t border-white/10">
              <p className="text-white/40 mb-4">Documentos relacionados:</p>
              <div className="flex gap-6">
                <Link to="/privacidad" className="text-white hover:opacity-60 transition-opacity">
                  Política de Privacidad →
                </Link>
              </div>
            </section>
          </div>
        </main>
      </div>
    </PageWrapper>
  );
};

export default TerminosPage;
